import React from "react";
import MyCards from "./MyCards";

const Cards = () => {
  return (
    <>
      <div className="body-cards">
        <MyCards />
      </div>
    </>
  );
};

export default Cards;
